import { render, staticRenderFns } from "./CarrierLicensePlate.vue?vue&type=template&id=2c9e8740&"
import script from "./CarrierLicensePlate.vue?vue&type=script&lang=js&"
export * from "./CarrierLicensePlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports